define.alias("ember-power-select/helpers/ember-power-select-is-group", "calendar/helpers/ember-power-select-is-group");